/**
* @author Andrés Ferreira
* @Copyright (c) Infotrack. All rights reserved.
*/
export default {
'sidebar.smartstock': 'Smart  Stock',
'sidebar.pisos': 'Floors',
'pisos.agregarFloors': 'Create Floors',
'pisos.confirmacionCreacion': 'Are you sure to create the registry?',
'pisos.confirmacionEdicion': 'You are sure you want to edit the registry?',
'pisos.confirmacionEliminacion': 'Are you sure you want to delete the registry?',
'pisos.modificarFloors': 'Edit Floors',
'pisos.eliminarFloors': 'Delete Floors',
'pisos.pisoId': 'Flat Id',
'pisos.empresaId': ' Company Id',
'pisos.descripcionPiso': ' Flat Description',
'pisos.floors': 'Floors',
'pisos.verFloors': 'View Floors',
};

